const utils = require('./utils');
const hooks = require('./hooks');

module.exports = Object.assign({}, utils, { hooks });



//////////////////
// WEBPACK FOOTER
// ./~/@feathersjs/commons/lib/index.js
// module id = 16
// module chunks = 0